import React from 'react';

export const Banner = (props) => {

  return(
    <div className="text-center">
      <h1 className="banner__heading"> {props.heading} </h1>
      <p className="banner__info"> {props.info} </p>
    </div>
  );
} 